// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// Add to your router/index.js

const routes = [
  {
    path: '/',
    component: () => import('@/components/layout/Layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue')
      },
      { path: '/data-explorer', name: 'DataExplorer', component: () => import('@/views/DataExplorer.vue'), meta: { requiresAuth: true } },
       { path: '/monitoring', name: 'SystemMonitoring', component: () => import('@/views/SystemMonitoring.vue'), meta: { requiresAuth: true } },
       { path: '/settings', name: 'Settings', component: () => import('@/views/Settings.vue'), meta: { requiresAuth: true } },
      {
        path: 'flow',
        name: 'Flow',
        component: () => import('@/views/Dashboard.vue'),
        meta: { section: 'flow' }
      },
      {
        path: 'analytics',
        name: 'Analytics',
        component: () => import('@/views/Dashboard.vue'),
        meta: { section: 'analytics' }
      },
      {
        path: 'finance',
        name: 'Finance',
        component: () => import('@/views/Dashboard.vue'),
        meta: { section: 'finance' }
      },
      {
        path: 'learning',
        name: 'Learning',
        component: () => import('@/views/Dashboard.vue'),
        meta: { section: 'learning' }
      },
      {
          path: '/ml-testing',
          name: 'MLTesting',
          component: () => import('@/components/testing/MLModelTesting.vue'),
          meta: {
            requiresAuth: true,
            title: 'ML Model Testing'
          }
        },
        {
          path: '/churn-dashboard',
          name: 'ChurnDashboard',
          component: () => import('@/views/ChurnAnalyticsDashboard.vue'),
          meta: {
            requiresAuth: true,
            title: 'Churn Dashboard'
          }
        },
      {
        path: '/ml-testing/dashboard',
        name: 'MLTestingDashboard',
        component: () => import('@/components/testing/TestingDashboard.vue'),
        meta: {
          requiresAuth: true,
          title: 'ML Model Testing Dashboard'
        }
      },
      {
        path: '/runway/dashboard',
        name: 'RunwayDashboard',
        component: () => import('@/components/runway/RunwayDashboard.vue'),
        meta: {
          requiresAuth: true,
          title: 'Runway Dashboard'
        }
      },
      {
        path: '/ml-testing/batch',
        name: 'MLTestingBatch',
        component: () => import('@/components/testing/BatchMLTesting.vue'),
        meta: {
          requiresAuth: true,
          title: 'ML Model Testing Batch'
        }
      },
      {
        path: '/ml-expense-fraud',
        name: 'MLExpenseFraud',
        component: () => import('@/views/ExpenseFraudDashboard.vue'),
        meta: {
          requiresAuth: true,
          title: 'ML Expense Fraud Detection'
        }
      },
      {
        path: '/churn-dashboard',
        name: 'ChurnDashboard',
        component: () => import('@/views/ChurnAnalyticsDashboard.vue'),
        meta: {
          requiresAuth: true,
          title: 'Churn Dashboard'
        }
      },
       {
    path: '/expense/policies',
    name: 'PolicyManagement',
    component: () => import('@/views/PolicyManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/risk-radar',
    name: 'RiskRadar',
    component: () => import('@/views/RiskRadarView.vue'),
    meta: {
      requiresAuth: true,
      title: 'Risk Radar - Sprint Delay Prediction'
    }
  },
  {
    path: '/risk-radar/pi/:id',
    name: 'PIDetails',
    component: () => import('@/components/risk-radar/PIDetailsDashboard.vue'),
    meta: {
      requiresAuth: true,
      title: 'PI Details - Risk Radar'
    }
  }


    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
   
]


const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router
